import { Button, Container, Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import React from "react";
import { Route } from "react-router";
import { unarchiveAuction } from "../../../services/AuctionService";
import { useSnackbar } from "notistack";

type UnarchiveBidderModalProps = {
    id: string;
    open: boolean;
    onClose: (value: React.SetStateAction<boolean>) => void;
    onUnarchive: () => void;
}

export const UnarchiveAuctionModal: React.FC<UnarchiveBidderModalProps> = props => {
    const { enqueueSnackbar } = useSnackbar();

    const unarchive = async () => {
        try {
            const feedback = await unarchiveAuction(props.id);
            
            if (feedback.parsedBody) {
                enqueueSnackbar(feedback.parsedBody.feedback, { variant: feedback.parsedBody.type });
            }
        } catch(_) {
            enqueueSnackbar("Something went wrong while unarchiving this auction.", { variant: 'error' })
        } finally {
            props.onUnarchive();
        }
    }

    const dialogContents = (
        <>
            <DialogTitle id="form-dialog-title">
                <Typography variant="h5">
                    Are you sure?
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Container style={{ padding: 0, paddingBottom: '12px' }}>
                    <Typography variant="body1" style={{ paddingBottom: '16px' }}>
                        Are you sure you wish to unarchive this auction?
                    </Typography>

                    <Container style={{ display: 'flex', justifyContent: 'end', gap: '2rem', padding: 0 }}>
                        <Button onClick={(_) => unarchive()} variant="contained" color="primary">Confirm</Button>

                        <Route
                            render={({ history }) => (
                            <Button onClick={() => props.onClose(false)}>
                                <Typography variant="subtitle1" gutterBottom>
                                Cancel
                                </Typography>
                            </Button>
                            )}
                        />
                    </Container>
                </Container>
            </DialogContent>
        </>
    )

    return (
        <Dialog open={props.open} fullWidth={true} aria-labelledby="form-dialog-title">
            {dialogContents}
        </Dialog>
    )
}